import { FC } from 'react';

import { PhoenixIcon } from '@phoenix/design-system/frontend/ui/phoenix-icon/phoenix-icon';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';
import { CompatibleBattery } from '@phoenix/team-m/dashboard/frontend/util/product/product-batteries.model';
import { DynamicLinkWrapper } from '@phoenix/team-m/dashboard/frontend/shared/dynamic-link-wrapper';
import { useImpressionEvent } from '@phoenix/core/frontend/shared/util/hooks/use-impression-event';
import { ecommerceEvents, ProductEventData } from '@phoenix/team-m/dashboard/frontend/shared/tracking/ecommerce.events';

import { BatteryDetails } from './battery-details';
import { BatteryRuntimeExtension } from './battery-runtime-extension';

const linkoutIcon = getDesignSystemIcon('icon-external-link-16.svg');

interface BatteryPromotionProps {
  battery: CompatibleBattery;
}

const mapToProductEventData = (b: CompatibleBattery): ProductEventData => ({
  item_id: b.materialNumber,
  item_name: b.productName,
  picture_url: b.imageUrl,
  index: b.index,
  item_list_name: 'dashboard',
  item_category: 'battery',
});

export const BatteryPromotion: FC<BatteryPromotionProps> = ({ battery }) => {
  const productEventData = mapToProductEventData(battery);

  return (
    <DynamicLinkWrapper
      ref={useImpressionEvent(() => ecommerceEvents.impression(productEventData))}
      onClick={() => ecommerceEvents.selection(productEventData)}
      hyperLink={battery.callToActionUrl}
      className="relative block items-center justify-between pr-4 tablet:flex"
      allowReferrer={true}
      dataTestId={`compatible-battery-${battery.materialNumber}`}
    >
      <BatteryDetails imageSrc={battery.imageUrl} productName={battery.productName} />
      <BatteryRuntimeExtension
        runtimePercentages={battery.runtimePercentages}
        maxRuntime={battery.maxRuntime}
        runtimeIncrease={battery.runtimeIncrease}
      />
      <PhoenixIcon icon={linkoutIcon} className="absolute right-4 top-4 h-4 w-4 tablet:static desktop:ml-8" />
    </DynamicLinkWrapper>
  );
};
